import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/delete-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "DELETE_PLANT" }
);

export interface DeletePlantState extends IState {}

const INITIAL_STATE: DeletePlantState = {
  loading: false,
  error: null,
};

const request = (state: DeletePlantState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: DeletePlantState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: DeletePlantState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const deletePlant = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const DeletePlantTypes = Types;
export const DeletePlantActions = Creators;
